// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yarl__navigation_prev,.yarl__navigation_next{display:none}", "",{"version":3,"sources":["webpack://./src/components/LightBox/LightBox.scss"],"names":[],"mappings":"AAAA,8CAEE,YAAA","sourcesContent":[".yarl__navigation_prev,\n.yarl__navigation_next {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
